@if (label) {
	<tec-form-group [label]="label" [errorMsg]="amountErrorMsg()">
		<div class="retention-duration" [formGroup]="internalForm">
			<tec-select
				formControlName="unit"
				[options]="unitOptions"
				[hasError]="hasError"
			/>
			@if (showAmountInput()) {
				<tec-input
					type="number"
					formControlName="amount"
					[hasError]="hasError || amountHasError()"
				/>
			}
		</div>
	</tec-form-group>
} @else {
	<div class="retention-duration" [formGroup]="internalForm">
		<tec-select
			formControlName="unit"
			[options]="unitOptions"
			[hasError]="hasError"
		/>
		@if (showAmountInput()) {
			<tec-input
				type="number"
				formControlName="amount"
				[hasError]="hasError || amountHasError()"
			/>
		}
	</div>
}
